import React from 'react';

const backendSkills = [
    ['C#', 'bx bx-code-curly'],
    ['ASP.NET Web API', 'bx bxl-microsoft'],
    ['ASP.NET MVC', 'bx bxl-microsoft'],
    ['ASP.NET Razor', 'bx bxs-layer'],
    ['Entity Framework Core', 'bx bx-layer-plus'],
    ['ADO.NET', 'bx bx-layer'],
    ['Dapper ORM', 'bx bx-data'],
    ['REST APIs', 'bx bx-transfer-alt'],
    ['SOLID Design Principles', 'bx bx-cube'],
    ['Object-Oriented Design', 'bx bxs-component'],
    ['Functional Programming', 'bx bx-git-branch'],
    ['Back-End Web Development', 'bx bx-server']
];

const Backend = () => {
    return (
        <div className="skills__content">
            <h3 className="skills__title bold">Backend Development</h3>

            <div className="skills__box">
                {backendSkills.map(([name, icon]) => (
                    <div className="skills__data" key={name}>
                        <i className={icon}></i>
                        <h3 className="skills__name">{name}</h3>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Backend;
